import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main/Main'
import Switcher from '@/components/products/switcher/Switcher'
import Linker from '@/components/products/linker/Linker'
import Checker from '@/components/products/checker/Checker'
import SubmitReview from '@/components/products/SubmitReview'
import Cart from '@/components/apply/cart/Cart'
import Plan from '@/components/apply/Plan'
import Customer from '@/components/apply/Customer'
import Card from '@/components/apply/Card'
import Complete from '@/components/apply/Complete'
import SideMenu from '@/components/SideMenu'
import FreeTrial from '@/components/FreeTrial'
import About from '@/components/About'
import Cash from '@/components/Cash'
import Promotion from '@/components/promotion/promotion'
import PromotionPayment from '@/components/promotion/promotionPayment'
import PromotionComplete from '@/components/promotion/promotionComplete'
import Terms from '@/components/Terms'
import Recommendation from '@/components/Recommendation'

import { IO_PRODUCTS } from '@/modules/products.js'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/switcher',
      name: 'Switcher',
      component: Switcher
    },
    {
      path: '/linker',
      name: 'Linker',
      component: Linker
    },
    {
      path: '/checker',
      name: 'Checker',
      component: Checker
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/apply/plan',
      name: 'Plan',
      component: Plan
    },
    {
      path: '/apply/customer',
      name: 'Customer',
      component: Customer
    },
    {
      path: '/apply/card',
      name: 'Card',
      component: Card
    },
    {
      path: '/sideMenu',
      name: 'SideMenu',
      component: SideMenu
    },
    {
      path: '/apply/complete',
      name: 'Complete',
      component: Complete
    },
    {
      path: '/freetrial',
      name: 'FreeTrial',
      component: FreeTrial
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/cash',
      name: 'Cash',
      component: Cash
    },
    {
      path: '/campaign',
      name: 'Promotion',
      component: Promotion
    },
    {
      path: '/campaign/payment',
      name: 'PromotionPayment',
      component: PromotionPayment
    },
    {
      path: '/campaign/complete',
      name: 'PromotionComplete',
      component: PromotionComplete
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/review/submit/' + IO_PRODUCTS.SWITCHER_ONE_BUTTON,
      alias: ['/review/submit/' + IO_PRODUCTS.SWITCHER_TWO_BUTTON, '/review/submit/' + IO_PRODUCTS.LINKER, '/review/submit/' + IO_PRODUCTS.CHECKER],
      name: 'SubmitReview',
      component: SubmitReview
    },
    {
      path: '/recommendation',
      name: 'Recommendation',
      component: Recommendation
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.has) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js